const updateArrayFilter = (currentValue, filterValue) => {
  const filterList = currentValue.split(',');
  const isItemActive = filterList.includes(filterValue);

  return isItemActive
    ? filterList.filter(item => item !== filterValue).join(',')
    : [...filterList, filterValue].join(',');
};

export const updateArrayIfNotActiveFilter = (currentValue, filterValue) => {
  const filterList = currentValue.split(',');
  const isItemActive = filterList.includes(filterValue);

  return isItemActive
    ? [currentValue].join(',')
    : [currentValue, filterValue].join(',')
};

export const addNewFilter = (filterKey, filterValue, filterListState) => {
  const newFilter = { [filterKey]: filterValue };
  return [...filterListState, newFilter];
};

const updateExistingFilter = (filterKey, newFilterValue, filterListState, filterIndex) => {
  if (newFilterValue) {
    const updatedFilter = { [filterKey]: newFilterValue };
    const newFilterListState = [...filterListState];
    newFilterListState[filterIndex] = updatedFilter;
    return newFilterListState;
  }
  return filterListState.filter((_, index) => index !== filterIndex);
};

const getFilterValue = (isArrayFilter, currentFilterValue, filterValue) => {
  return isArrayFilter 
    ? updateArrayFilter(currentFilterValue, filterValue)
    : filterValue;
};

export const handleFilterUpdate = (state, filterKey, filterValue) => {
  const oldFilterState = state.filtersList;
  const currentFilter = oldFilterState.find(item => item.hasOwnProperty(filterKey));
  const isArrayFilter = filterKey.includes('[]');

  if (!currentFilter) {
    return addNewFilter(filterKey, filterValue, oldFilterState);
  }

  const currentFilterValue = Object.values(currentFilter)[0];
  const newFilterValue = getFilterValue(isArrayFilter, currentFilterValue, filterValue);
  const filterIndex = oldFilterState.indexOf(currentFilter);

  return updateExistingFilter(filterKey, newFilterValue, oldFilterState, filterIndex);
};

export const handleFilterAdd = (state, filterKey, filterValue) => {
  const oldFilterState = state.filtersList
  const currentFilter = oldFilterState.find(item => item.hasOwnProperty(filterKey))
  const isAnArrayFilter = filterKey.includes('[]')
  
  let newFilterValue;
  let newFilterListState = oldFilterState

  if (!currentFilter) {
    newFilterValue = filterValue
    const newFilter = { [filterKey]: newFilterValue }

    newFilterListState.push(newFilter)

    return [...newFilterListState]
  }

  if (isAnArrayFilter) {
    const currentFilterValue = Object.values(currentFilter)[0]
    const isItemActive = currentFilterValue.includes(filterValue);
    const newFilterList = isItemActive ? [currentFilterValue] : [currentFilterValue, filterValue]

    newFilterValue = newFilterList.join(',')
  } else {
    newFilterValue = filterValue
  }

  const filterIndex = oldFilterState.indexOf(currentFilter)

  if (newFilterValue) {
    const newFilter = { [filterKey]: newFilterValue }
    newFilterListState[filterIndex] = newFilter
  } else {
    newFilterListState.splice(filterIndex, 1)
  }

  return [...newFilterListState]
}
